import './src/styles/reset.css'
import './src/styles/global.css'
import './src/styles/custom.css'
import './src/styles/icons.css'
import React from 'react'
import RootElement from './src/components/RootElement'

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  // override `shouldUpdateScroll` behaviour to bypass useQueryParams in store filters
  if (
    location.search.includes('lat=') ||
    location.search.includes('postcode=')
  ) {
    return false
  }
  const currentPosition = getSavedScrollPosition(location)
  return currentPosition || [0, 0]
}

export const wrapRootElement = ({ element }) => {
  return <RootElement>{element}</RootElement>
}
